var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "25",
        viewBox: "0 0 20 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("line", {
        attrs: {
          x1: "0.353516",
          y1: "8.63623",
          x2: "15.0199",
          y2: "8.63623",
          stroke: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M18.8641 18.5075C18.8641 21.6244 16.2855 24.1752 13.0746 24.1752C9.86384 24.1752 7.28516 21.6244 7.28516 18.5075C7.28516 15.3906 9.86384 12.8398 13.0746 12.8398C16.2855 12.8398 18.8641 15.3906 18.8641 18.5075Z",
          stroke: "white",
          "stroke-width": "1.5"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M6.23806 1.2168C6.23806 0.802583 5.90227 0.466797 5.48806 0.466797C5.07384 0.466797 4.73806 0.802583 4.73806 1.2168V2.67883H2.35352C1.24895 2.67883 0.353516 3.57426 0.353516 4.67883V17.188C0.353516 18.2926 1.24895 19.188 2.35352 19.188H4.85046C4.83122 18.9636 4.82141 18.7366 4.82141 18.5073C4.82141 18.2307 4.83569 17.9574 4.86357 17.688H2.35352C2.07737 17.688 1.85352 17.4642 1.85352 17.188V4.67883C1.85352 4.40268 2.07737 4.17883 2.35352 4.17883H4.73806V6.34462C4.73806 6.75884 5.07384 7.09462 5.48806 7.09462C5.90227 7.09462 6.23806 6.75884 6.23806 6.34462V4.17883H10.343V6.34462C10.343 6.75884 10.6788 7.09462 11.093 7.09462C11.5072 7.09462 11.843 6.75884 11.843 6.34462V4.17883H14.8569C15.1331 4.17883 15.3569 4.40269 15.3569 4.67883V10.8375C15.8812 10.9934 16.3831 11.1996 16.8569 11.4504V4.67883C16.8569 3.57426 15.9615 2.67883 14.8569 2.67883H11.843V1.2168C11.843 0.802583 11.5072 0.466797 11.093 0.466797C10.6788 0.466797 10.343 0.802583 10.343 1.2168V2.67883H6.23806V1.2168Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.9922 15.7485V19.093L15.3517 20.3795",
          stroke: "white",
          "stroke-linecap": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }